import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';


class Slider extends Component {
    constructor(props) {
        super(props);
        this.translate = 0;
        this.prevSlide = this.prevSlide.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.state = {
            url: props.url,
            chartData: [],
            widget_title: this.props.title,
            heading_text: this.props.headingtext,
           
        }
    }
    fetchData() {
        const requestOptions = {
            method: 'GET',
            //headers: { 'Content-Type': 'application/json', 'Access-Control-Request-Method': 'GET', 'Access-Control-Request-Headers': 'Origin,Content-Type'}
        };
        fetch(this.state.url, requestOptions)
            .then(resp => resp.text())
            .then(data => {
                data = data.replace(/\"/g, "");
                var dataArr = data.split("\n");
                var dataObj = [];
                var dataset = new Array();
                var maxValue = 0, lastElementValue = 0;
                for (var i = 0; i < dataArr.length; i++) {
                    var temp = dataArr[i].split(",");
                    dataObj = [];
                    lastElementValue = 0;
                    if (temp[0] != "Color" && temp[0] != "Total" && temp[0] != "Average" && temp[0] != "" && temp[0] != "Month") {
                        for (var j = 0; j < temp.length; j++) {
                            if (i == 1 && j == temp.length - 1) {
                                maxValue = parseFloat(temp[j])
                            }
                            if (j == temp.length - 1) {
                                lastElementValue = temp[j];
                            }
                            dataObj.push({ data: temp[j], MaxValue: maxValue, lastElementValue: lastElementValue });
                        }
                        dataset.push(dataObj)
                    }
                }
                //console.log( dataset);
                this.setState({
                    ...this.state,
                    chartData: dataset
                });
            });
    }

    prevSlide() {
        let selectId = 'ListContainer_' + this.state.widget_title.replace(" ", "").replace(" ", "");
        let list = document.getElementById(selectId);
        if (this.translate == 0) {
            this.translate -= 270;
            list.style.transform = "translateX(" + this.translate + "px" + ")";
        }
        this.translate += 270;
        list.style.transform = "translateX(" + this.translate + "px" + ")";
    }

    nextSlide() {
        let selectId = 'ListContainer_' + this.state.widget_title.replace(" ", "").replace(" ", "");
        let list = document.getElementById(selectId);
        let allList = document.querySelectorAll('.monthlyTransition').length - 4;
        let completeWidth = allList * 270;
        let newTranslate = -this.translate;
        if (!(newTranslate >= completeWidth)) {
            this.translate -= 270;
            list.style.transform = "translateX(" + this.translate + "px" + ")";
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProp) {
        if (prevProp.url != this.props.url) {
            this.fetchData();
        }
    }
  

    render() {
        const flyoutWidth = window.innerWidth - 480;
        let flyoutStyle = {
            width: 1065 + 'px',
            marginLeft: 65
        }

        return (
            <div className="widget ui-draggable ui-resizable full-layout raw-transition">
                <div className="widget-head" >
                    <h3>
                        <a data-original-title title="true">{this.state.widget_title}</a>
                    </h3>
                </div>
                <div className="widget-content">
                    <div className="adjustWidth" style={flyoutStyle}>
                        <div className="scrolling-wrapper">

                            <div id={"ListContainer_" + this.state.widget_title.replace(" ", "").replace(" ", "")}>

                                {
                                    this.state.chartData.map((item, index) => {

                                        return (

                                            <div key={index} className="monthlyTransition">
                                                <h2>{this.state.heading_text}</h2>

                                                <div className="left">
                                                    <span className="month">{item[0].data}</span>
                                                    <span className="year">{item[1].data}</span>
                                                </div>
                                                <div className="right">
                                                    <a target="_blank" href={item[2].data}>Download Here</a>
                                                    <FontAwesomeIcon className="bounce" icon={faArrowDown} color="white" />
                                                </div>
                                            </div>

                                        )
                                    })
                                }

                            </div>

                            <button className="w3-button w3-display-left w3-black" onClick={() => this.prevSlide()}>&#10094;</button>
                            <button className="w3-button w3-display-right w3-black" onClick={() => this.nextSlide()}>&#10095;</button>

                        </div>

                    </div>
                </div>
                <div className="widget-foot">
                    &nbsp;
                </div>
            </div>
        )
    }
}
export default Slider;